import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suppress ResizeObserver loop errors (benign browser issue)
const resizeObserverError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (message && message.includes && message.includes('ResizeObserver')) {
    return true;
  }
  return resizeObserverError ? resizeObserverError(message, source, lineno, colno, error) : false;
};

// Also handle unhandledrejection for ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.stopPropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
